import { type ComponentType } from 'react';
import { Factorial } from '../components/integrations2.0/Factorial';
import { A3 } from '../components/integrations2.0/A3/A3';
import { Personio } from '../components/integrations2.0/Personio/Personio';
import { Castilla } from '../components/integrations2.0/Castilla';
import { Buk } from '../components/integrations2.0/Buk';
import { Bizneo } from '../components/integrations2.0/Bizneo';
import PublicApiForm from '../components/integrations/PublicApi';
import { type IntegrationProps } from './hooks';

// Only integrations listed here have a wizard. Anything else redirects back to the list.
export const integrationForms: Record<string, ComponentType<IntegrationProps>> = {
  factorial: Factorial,
  a3api: A3,
  personio: Personio,
  grupoCastillaEpsilon: Castilla,
  buk: Buk,
  api: PublicApiForm,
  bizneo: Bizneo
};

export const hasIntegrationForm = (integrationName: string) => integrationName in integrationForms;
